import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const SeatOutlineIcon: React.FC<OneColorIconProps> = ({ size = 24, color = 'black', className }) => {
  const hex = getHexColor(color)

  return (
    <svg className={className} width={size} height={size} fill="none" viewBox="0 0 20 20">
      <path
        fill={hex}
        fillRule="evenodd"
        d="M2.5 5A2.5 2.5 0 0 1 5 2.5h10A2.5 2.5 0 0 1 17.5 5v7.5c-1.417 0-15 .065-15 0zM5 4.167A.833.833 0 0 0 4.167 5v5.833h11.666V5A.833.833 0 0 0 15 4.167zM2.5 14.167v1.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667v-1.666z"
        clipRule="evenodd"
      />
    </svg>
  )
}
